import "./App.css";
import HomePage from "./components/HomePage";
import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId: "GTM-WPGRJF76",
};

TagManager.initialize(tagManagerArgs);

function App() {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}

export default App;
